import {
  EventStreamContentType,
  fetchEventSource,
} from '@microsoft/fetch-event-source';
import type { Listener, Source } from 'react-hooks-sse';
import { CSRF_HEADER } from './csrf-header';

export class EventSource implements Source {
  public static readonly DEFAULT_RETRY_INTERVAL = 3000;

  private readonly src = new EventTarget();

  private listeners = new Map<Listener, EventListener>();

  private readonly ctrl = new AbortController();

  constructor(url: string) {
    fetchEventSource(url, {
      headers: CSRF_HEADER,
      onopen: async (response) => {
        if (
          !response.ok ||
          response.headers.get('content-type') !== EventStreamContentType
        ) {
          throw new Error();
        }
      },
      onmessage: (event) => {
        this.src.dispatchEvent(
          new CustomEvent(event.event, { detail: event.data }),
        );
      },
      onclose: () => {
        throw new Error();
      },
      // TODO: arbitrary retry interval, might want to do backoff
      //       and possibly notify the person
      onerror: () => EventSource.DEFAULT_RETRY_INTERVAL,
      signal: this.ctrl.signal,
    });
  }

  addEventListener(name: string, listener: Listener): void {
    const eventListener = ((e: CustomEvent<string>) =>
      listener({ data: e.detail })) as EventListener;
    this.listeners.set(listener, eventListener);
    this.src.addEventListener(name, eventListener);
  }

  removeEventListener(name: string, listener: Listener): void {
    const eventListener = this.listeners.get(listener);
    if (eventListener) {
      this.src.removeEventListener(name, eventListener);
      this.listeners.delete(listener);
    }
  }

  close() {
    this.ctrl.abort();
  }
}
